import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'ngx-app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent {
  requestForm: FormGroup;
  verifyForm: FormGroup;

  mode: 'request' | 'verify' = 'request';
  clicked: boolean = false;
  isAuthenticating: boolean = false;
  errorMessage: string = '';
  baseUrl: string = 'account';

  email: string = '';

  constructor(private api: ApiService, private router: Router) {
    this.requestForm = new FormGroup({
      Email: new FormControl(null, [Validators.required, Validators.email])
    });
    this.verifyForm = new FormGroup({
      Otp: new FormControl(null, [Validators.required]),
      NewPassword: new FormControl(null, [Validators.required]),
      ConfirmPassword: new FormControl(null, [Validators.required])
    });
  }

  requestReset() {
    this.clicked = true;
    if (!this.requestForm.valid) {
      return;
    }

    this.isAuthenticating = true;
    this.errorMessage = '';
    this.email = this.requestForm.value.Email;

    this.api.postText(`${this.baseUrl}/forgotpassword`, this.requestForm.value).subscribe(() => {
      this.isAuthenticating = false;
      this.clicked = false;
      this.mode = 'verify';
    }, (error: any) => {
      this.isAuthenticating = false;
      this.clicked = false;
      const message = this.extractErrorMessage(error);
      this.errorMessage = message;
      const title = error && error.status === 404 ? 'User Not Found' : 'Unable to send code';
      Swal.fire({ title, text: message, icon: 'error' });
    });
  }

  private extractErrorMessage(error: any): string {
    const err = error && error.error;
    if (typeof err === 'string' && err.trim()) {
      return err;
    }
    if (err && typeof err.title === 'string' && err.title.trim()) {
      return err.title;
    }
    if (err && typeof err.text === 'string' && err.text.trim()) {
      return err.text;
    }
    if (err && typeof err.message === 'string' && err.message.trim()) {
      return err.message;
    }
    if (error && typeof error.message === 'string' && error.message.trim()) {
      return error.message;
    }
    return 'Something went wrong. Please try again.';
  }

  verifyAndReset() {
    this.clicked = true;
    if (!this.verifyForm.valid) {
      return;
    }

    const { Otp, NewPassword, ConfirmPassword } = this.verifyForm.value;
    if (NewPassword !== ConfirmPassword) {
      this.errorMessage = 'Passwords do not match.';
      return;
    }

    this.isAuthenticating = true;
    this.errorMessage = '';
    const payload = {
      Email: this.email,
      Otp: Otp,
      Password: NewPassword,
      ConfirmPassword: ConfirmPassword
    };
    this.api.post(`${this.baseUrl}/resetpasswordwithotp`, payload).subscribe(() => {
      this.isAuthenticating = false;
      setTimeout(() => {
        this.router.navigateByUrl('auth/login');
      }, 2000);
    }, (error: any) => {
      this.isAuthenticating = false;
      this.errorMessage = this.extractErrorMessage(error);
    });
  }

  backToLogin() {
    this.router.navigate(['/auth/login']);
  }
}
